var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{style:(_vm.getStyle()),attrs:{"disabled":_vm.disabled,"type":_vm.type},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.slotAfter ? _vm.value : '')+" "),_vm._t("default"),_vm._v(" "+_vm._s(!_vm.slotAfter ? _vm.value : '')+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }